import { cn } from '@/utils/styles';
import Link from 'components/shared/Link/Link';
import Media from 'components/shared/Media/Media';
import { AuthorProps } from 'libs/contentful/props';
import { liveUpdateAttrs } from 'libs/contentful/utils';

type BlogAuthorProps = AuthorProps & {
  className?: string;
};

const BlogAuthor = ({ name, title, image, url, internalPage, sys, className }: BlogAuthorProps) => {
  const hasLink = url || internalPage;

  return (
    <div className={cn('flex gap-4 items-center', className)}>
      {image && (
        <div className="h-12 w-12 rounded-full">
          {<Media media={image} className="object-cover rounded-full h-full" />}
        </div>
      )}
      <div className="font-sans items-center">
        <p className="text-label-saans font-[640]" {...liveUpdateAttrs(sys?.id, 'name')}>
          <span className="text-content-secondary">Written by</span>{' '}
          {hasLink ? (
            <Link href={url} internalPage={internalPage}>
              {name}
            </Link>
          ) : (
            name
          )}
        </p>
        {title && (
          <p className="text-content-secondary font-[540] leading-[1.2]" {...liveUpdateAttrs(sys?.id, 'title')}>
            {title}
          </p>
        )}
      </div>
    </div>
  );
};

export default BlogAuthor;
